export default __webpack_public_path__ + "static/artifakt-element-light-eee84aab5e5ba4cfffe8c5d1b2cecf7e.ttf";